<template>
  <el-row v-bind="$props"> <slot /> </el-row>
</template>

<script>
export default {
  name: 'RtRow',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    gutter: {
      type: Number,
      default: 32
    },
    type: String,
    justify: {
      type: String,
      default: 'start'
    },
    align: {
      type: String,
      default: 'top'
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtRow.vue?5e871db0